import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../auth/AuthProvider';

export const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isRestoring } = useAuth();

  if (isRestoring) {
    return (
      <div className="min-h-screen w-full flex flex-col items-center justify-center gap-3 bg-[#f5f7fb]">
        <Spin size="large" />
        <span className="text-slate-500 text-sm">Loading session...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
